export default {
  CallWebHook: {
    Roles: ['admin', 'user'],
    EventName: 'CallWebHook',
    EventWeight: 1130,
    DisplayName: 'Call Webhook',
    Icon: 'fa fa-external-link-square',
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Webhook Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      url: {
        IsStrValue: true,
        EventFieldName: 'url',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Url',
          FieldName: 'url',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      httpMethod: {
        IsStrValue: true,
        EventFieldName: 'httpMethod',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Http Method',
          FieldName: 'httpMethod',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      contentType: {
        IsStrValue: true,
        EventFieldName: 'contentType',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Content Type',
          FieldName: 'contentType',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      content: {
        IsStrValue: true,
        EventFieldName: 'content',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Content',
          FieldName: 'content',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  UploadOfflineConversion: {
    Roles: ['admin', 'user'],
    EventName: 'UploadOfflineConversion',
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Upload Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'failReason',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Failed',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      }
    }
  },
  UploadOfflineConversionGadsSuccess: {
    Roles: ['admin', 'user'],
    EventName: 'UploadOfflineConversionGadsSuccess',
    DisplayName: 'Upload Offline Conversion',
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Upload Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'failReason',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Failed',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      },
      successfulUpload: {
        IsValue: true,
        EventFieldName: 'successfulUpload',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Successful',
          FieldName: 'successfulUpload',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'bool',
          IsGroupable: false
        }
      }
    }
  },
  UploadOfflineConversionGadsFailure: {
    Roles: ['admin', 'user'],
    EventName: 'UploadOfflineConversionGadsFailure',
    DisplayName: 'Upload Offline Conversion',
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Upload Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'failReason',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Failed',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      },
      successfulUpload: {
        IsValue: true,
        EventFieldName: 'successfulUpload',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Successful',
          FieldName: 'successfulUpload',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'bool',
          IsGroupable: false
        }
      }
    }
  },
  PixelFire: {
    Roles: ['admin', 'user'],
    EventName: 'PixelFire',
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Webhook Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'failReason',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Failed',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      },
      recordingUrl: {
        IsValue: false,
        EventFieldName: 'recordingUrl',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Url',
          FieldName: 'recordingUrl',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      eventId: {
        IsValue: false,
        EventFieldName: 'eventId',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Setting Id',
          FieldName: 'eventId',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      eventName: {
        IsValue: false,
        EventFieldName: 'eventName',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Setting Name',
          FieldName: 'eventName',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      eventCode: {
        IsValue: false,
        EventFieldName: 'eventCode',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Trigger On',
          FieldName: 'eventCode',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      httpStatusCode: {
        IsValue: false,
        EventFieldName: 'httpStatusCode',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Response Status Code',
          FieldName: 'httpStatusCode',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  VoidedCall: {
    Roles: ['admin', 'user'],
    EventName: 'VoidedCall',
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Webhook Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'failReason',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Void Reason',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      }
    }
  },
  EndCallSource: {
    Roles: ['admin', 'user'],
    EventName: 'EndCallSource',
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      Source: {
        IsStrValue: true,
        EventFieldName: 'source',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Hangup',
          FieldName: 'source',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      }
    }
  },
  ConnectedCall: {
    Roles: ['admin', 'affiliate', 'buyer', 'user'],
    EventName: 'ConnectedCall',
    DisplayName: 'Connected',
    EventWeight: '500',
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Connected Date',
          FieldName: 'dtStamp',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      timeToConnect: {
        IsValue: true,
        EventFieldName: 'timeToConnect',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Time to Connect',
          FieldName: 'timeToConnect',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          FieldType: 'seconds',
          Scubbers: 'positive',
          IsRange: true
        }
      },
      callConnectionDt: {
        IsValue: true,
        EventFieldName: 'callConnectionDt',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Connection Time',
          FieldName: 'callConnectionDt',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          FieldType: 'date',
          IsSearchable: false
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text',
          IsGroupable: true
        }
      },
      targetNumber: {
        EventFieldName: 'targetNumber',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Number',
          FieldName: 'targetNumber',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  ConvertedCall: {
    Roles: ['admin', 'buyer', 'user'],
    EventName: 'ConvertedCall',
    DisplayName: 'Converted',
    EventWeight: 600,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Conversion Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          Scubbers: 'date'
        }
      },
      conversionAmount: {
        IsValue: true,
        EventFieldName: 'conversionAmount',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Conversion Amount',
          FieldName: 'conversionAmount',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'currency',
          IsRange: true
        }
      },
      payoutAmount: {
        IsValue: true,
        EventFieldName: 'payoutAmount',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Payout',
          DisplayNameShort: 'Conversion Payout',
          FieldName: 'payoutAmount',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      'targetName': {
        'IsValue': false,
        'EventFieldName': 'targetName',
        'ShouldFlaten': true,
        'Field': {
          'DisplayName': 'Target Name',
          'FieldName': 'targetName',
          'IsHidden': false,
          'Roles': ['admin', 'buyer', 'user'],
          'FieldType': 'text',
          'IsGroupable': true

        }
      },
      'targetNumber': {
        'EventFieldName': 'targetNumber',
        'ShouldFlaten': true,
        'Field': {
          'DisplayName': 'Target Number',
          'FieldName': 'targetNumber',
          'IsHidden': true,
          'Roles': ['admin', 'buyer', 'user'],
          'FieldType': 'text'
        }
      },
      'targetId': {
        'IsValue': false,
        'EventFieldName': 'targetId',
        'ShouldFlaten': true,
        'Field': {
          'DisplayName': 'Target ID',
          'FieldName': 'targetId',
          'IsHidden': true,
          'Roles': ['admin', 'buyer', 'user'],
          'FieldType': 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  PayoutCall: {
    Roles: ['admin', 'affiliate', 'user'],
    EventName: 'PayoutCall',
    EventWeight: 610,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Payout Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'user'],
          Scubbers: 'date'
        }
      },
      payoutAmount: {
        IsValue: true,
        EventFieldName: 'payoutAmount',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Payout',
          DisplayNameForRoles: {
            publisher: 'Revenue'
          },
          FieldName: 'payoutAmount',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'user'],
          FieldType: 'currency',
          IsRange: true
        }
      }
    }
  },
  NoPayoutCall: {
    Roles: ['admin', 'affiliate', 'user'],
    EventName: 'NoPayoutCall',
    EventWeight: 615,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Payout Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'failReason',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'No Payout Reason',
          FieldName: 'failReason',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      }
    }
  },
  NoConversionCall: {
    Roles: ['admin', 'buyer', 'user'],
    EventName: 'NoConversionCall',
    EventWeight: 615,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Conversion Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'failReason',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'No Conversion Reason',
          FieldName: 'failReason',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text',
          IsGroupable: false
        }
      }
    }
  },
  TargetDialed: {
    Roles: ['admin', 'buyer', 'user'],
    EventName: 'TargetDialed',
    EventWeight: '410',
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Completed Date',
          FieldName: 'dtStamp',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text',
          IsGroupable: true
        }
      },
      targetNumber: {
        EventFieldName: 'targetNumber',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Number',
          FieldName: 'targetNumber',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      totalAmount: {
        IsValue: true,
        EventFieldName: 'totalAmount',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Cost',
          FieldName: 'totalAmount',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'currency',
          IsSearchable: false
        }
      }
    }
  },
  CompletedCall: {
    Roles: ['admin', 'affiliate', 'buyer', 'user'],
    SettingBasedPermissions: ['affiliate:AccessToRecordings'],
    EventName: 'CompletedCall',
    DisplayName: 'Completed',
    EventWeight: '700',
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Completed Date',
          FieldName: 'dtStamp',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      callLengthInSeconds: {
        IsValue: true,
        EventFieldName: 'callLengthInSeconds',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Call Length',
          FieldName: 'callLengthInSeconds',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          FieldType: 'seconds',
          Scubbers: 'positive',
          IsRange: true
        }
      },
      callCompletedDt: {
        IsValue: true,
        EventFieldName: 'callCompletedDt',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Completion Time',
          FieldName: 'callCompletedDt',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          FieldType: 'date'
        }
      },
      callConnectionDt: {
        IsValue: true,
        EventFieldName: 'callCompletedDt',
        Field: {
          DisplayName: 'Call Connected Time',
          FieldName: 'callCompletedDt',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          FieldType: 'date'
        }
      },
      recordingUrl: {
        IsValue: false,
        EventFieldName: 'recordingUrl',
        ShouldFlaten: true,
        Override: false,
        Field: {
          DisplayName: 'Recording',
          FieldName: 'recordingUrl',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          SettingBasedPermissions: ['affiliate:AccessToRecordings'],
          FieldType: 'recording'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      totalAmount: {
        IsValue: true,
        EventFieldName: 'totalAmount',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Cost',
          FieldName: 'totalAmount',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'currency',
          IsSearchable: false
        }
      }
    }
  },
  BlockedCall: {
    Roles: ['admin', 'affiliate', 'user'],
    EventName: 'BlockedCall',
    EventWeight: '210',
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Blocked Date',
          FieldName: 'dtStamp',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'Reason',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Reason',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  RejectedForFunds: {
    Roles: ['admin', 'user'],
    EventName: 'RejectedForFunds',
    EventWeight: '211',
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Rejected Date',
          FieldName: 'dtStamp',
          IsHidden: true,
          Roles: ['admin', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      }
    }
  },
  NoTargetsAnswered: {
    Roles: ['admin', 'user'],
    EventName: 'NoTargetsAnswered',
    EventWeight: '212',
    Fields: {}
  },
  CallRecordingMigrated: {
    Roles: ['admin', 'buyer', 'user'],
    EventName: 'CallRecordingMigrated',
    DisplayName: 'Recorded',
    EventWeight: '1030',
    SettingBasedPermissions: ['affiliate:AccessToRecordings'],
    Fields: {
      recordingUrl: {
        IsValue: false,
        EventFieldName: 'recordingUrl',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Recording Url',
          FieldName: 'recordingUrl',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text',
          IsGroupable: true,
          SettingBasedPermissions: ['affiliate:AccessToRecordings']
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  ParentHangupRerouted: {
    Roles: ['admin', 'user'],
    EventName: 'ParentHangupRerouted',
    DisplayName: 'Revenue Recovery',
    EventWeight: '1050',
    SettingBasedPermissions: [],
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      childCallId: {
        IsValue: true,
        EventFieldName: 'childCallId',
        Field: {
          DisplayName: 'Recovered Inbound Call Id',
          FieldName: 'childCallId',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string',
          IsSearchable: false
        }
      }
    }
  },
  ChildHangupRerouted: {
    Roles: ['admin', 'user'],
    EventName: 'ChildHangupRerouted',
    DisplayName: 'Incoming Revenue Recovery',
    EventWeight: '1050',
    SettingBasedPermissions: [],
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      parentCallId: {
        IsValue: true,
        EventFieldName: 'parentCallId',
        Field: {
          DisplayName: 'Previous Inbound Call Id',
          FieldName: 'parentCallId',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      rerouteDepth: {
        IsValue: true,
        EventFieldName: 'rerouteDepth',
        Field: {
          DisplayName: 'Revenue Recovery Depth',
          FieldName: 'rerouteDepth',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string',
          IsSearchable: false
        }
      }
    }
  },
  CallTranscription: {
    Roles: ['admin', 'user'],
    EventName: 'CallTranscription',
    DisplayName: 'Transcription',
    EventWeight: '1035',
    SettingBasedPermissions: [],
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Billable Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'seconds',
          Scubbers: 'positive',
          IsRange: true
        }
      },
      amount: {
        IsValue: true,
        EventFieldName: 'cost',
        Field: {
          DisplayName: 'Cost',
          FieldName: 'amount',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      sentimentAnalyzed: {
        IsValue: true,
        EventFieldName: 'sentimentAnalysis',
        Field: {
          DisplayName: 'Sentiment Analyzed',
          FieldName: 'sentimentAnalysis',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'bool',
          IsSearchable: false
        }
      },
      sentiment: {
        IsValue: true,
        EventFieldName: 'sentiment',
        Field: {
          DisplayName: 'sentiment',
          FieldName: 'Sentiment',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string',
          IsSearchable: false
        }
      }
    }
  },
  TranscriptionRequested: {
    Roles: [ 'admin', 'user' ],
    EventName: 'TranscriptionRequested',
    DisplayName: 'Transcription Requested',
    EventWeight: '1034',
    SettingBasedPermissions: [],
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      requestorIPAddress: {
        IsValue: true,
        EventFieldName: 'requestorIPAddress',
        Field: {
          DisplayName: 'Requesting IP Address',
          FieldName: 'requestorIPAddress',
          IsHidden: false,
          Roles: [ 'admin', 'user' ],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      who: {
        IsValue: true,
        EventFieldName: 'who',
        Field: {
          DisplayName: 'Source',
          FieldName: 'who',
          IsHidden: false,
          Roles: [ 'admin', 'user' ],
          FieldType: 'string',
          IsSearchable: false
        }
      },
    }
  },
  TranscriptionError: {
    Roles: [ 'admin', 'user' ],
    EventName: 'TranscriptionError',
    DisplayName: 'Transcription',
    EventWeight: '1034',
    SettingBasedPermissions: [],
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      requestorIPAddress: {
        IsValue: true,
        EventFieldName: 'requestorIPAddress',
        Field: {
          DisplayName: 'Requesting IP Address',
          FieldName: 'requestorIPAddress',
          IsHidden: false,
          Roles: [ 'admin', 'user' ],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      who: {
        IsValue: true,
        EventFieldName: 'who',
        Field: {
          DisplayName: 'Source',
          FieldName: 'who',
          IsHidden: false,
          Roles: [ 'admin', 'user' ],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: [ 'admin', 'user' ],
          FieldType: 'string',
          IsSearchable: false
        }
      }
    }
  },
  NoTargetFound: {
    Roles: ['admin', 'user'],
    EventName: 'NoTargetFound',
    EventWeight: '210',
    Fields: {}
  },
  BusyCall: {
    Roles: ['admin', 'buyer', 'user'],
    EventName: 'BusyCall',
    EventWeight: '120',
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Connected Date',
          FieldName: 'dtStamp',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'buyer', 'user'],
          Scubbers: 'date',
          FieldType: 'date'
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text',
          IsGroupable: true
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  NoAnswer: {
    Roles: ['admin', 'buyer', 'user'],
    EventName: 'NoAnswer',
    EventWeight: '130',
    Fields: {
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text',
          IsGroupable: true
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  ErrorCall: {
    Roles: ['admin', 'buyer', 'user'],
    EventName: 'ErrorCall',
    EventWeight: '131',
    Fields: {
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text',
          IsGroupable: true
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  UserInputFail: {
    Roles: ['admin', 'user'],
    EventName: 'UserInputFail',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'Reason',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Reason',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  UserInput: {
    Roles: ['admin', 'user'],
    EventName: 'UserInput',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'Digits',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Digits',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  RecordedCallFail: {
    Roles: ['admin', 'user'],
    EventName: 'RecordedCallFail',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'Reason',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Reason',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  DuplicateCall: {
    Roles: ['admin', 'user', 'affiliate'],
    EventName: 'DuplicateCall',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user', 'affiliate'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'CallID',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Last Inbound Call ID',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      recordingUrl: {
        IsValue: false,
        EventFieldName: 'ConnectedTargetID',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Connected Target ID',
          FieldName: 'recordingUrl',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      lastCallDT: {
        IsValue: true,
        EventFieldName: 'LastCallTimestamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Last Call Date',
          FieldName: 'lastCallDT',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'user'],
          FieldType: 'date',
          IsSearchable: false
        }
      }
    }
  },
  IncompleteCall: {
    Roles: ['admin', 'user', 'affiliate'],
    EventName: 'IncompleteCall',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user', 'affiliate'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'Reason',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Reason',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user', 'affiliate'],
          FieldType: 'string'
        }
      },
      callLengthInSeconds: {
        IsValue: true,
        EventFieldName: 'callLengthInSeconds',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Call Length',
          FieldName: 'callLengthInSeconds',
          IsHidden: false,
          Roles: ['admin', 'affiliate', 'user'],
          FieldType: 'seconds',
          Scubbers: 'positive',
          IsRange: true
        }
      },
      callCompletedDt: {
        IsValue: true,
        EventFieldName: 'callCompletedDt',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Completion Time',
          FieldName: 'callCompletedDt',
          IsHidden: true,
          Roles: ['admin', 'affiliate', 'user'],
          FieldType: 'date'
        }
      },
      totalAmount: {
        IsValue: true,
        EventFieldName: 'totalAmount',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Cost',
          FieldName: 'totalAmount',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'currency',
          IsSearchable: false
        }
      }
    }
  },
  IVRNodeEnter: {
    Roles: ['admin', 'user'],
    EventName: 'IVRNodeEnter',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'NodeType',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'NodeType',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      stepName: {
        IsStrValue: true,
        EventFieldName: 'stepName',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Step Name',
          FieldName: 'stepName',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  IVRNodeExit: {
    Roles: ['admin', 'user'],
    EventName: 'IVRNodeExit',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsValue: false,
        EventFieldName: 'NodeType',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'NodeType',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      },
      stepName: {
        IsStrValue: true,
        EventFieldName: 'stepName',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Step Name',
          FieldName: 'stepName',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'string'
        }
      }
    }
  },
  SplitTestSelected: {
    Roles: [
      'admin',
      'user'
    ],
    EventName: 'SplitTestSelected',
    DisplayName: 'Splitter Result',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: [
            'admin',
            'user'
          ],
          Scubbers: 'date'
        }
      },
      selectedSplitName: {
        IsValue: false,
        EventFieldName: 'SelectedRoute',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Selected Route',
          FieldName: 'selectedSplitName',
          IsHidden: false,
          Roles: [
            'admin',
            'user'
          ],
          FieldType: 'string'
        }
      },
      selectedSplitWeight: {
        IsStrValue: true,
        EventFieldName: 'SelectedRouteWeight',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Selected Route Weight',
          FieldName: 'selectedSplitWeight',
          IsHidden: false,
          Roles: [
            'admin',
            'user'
          ],
          FieldType: 'string'
        }
      },
      selectedSplitChance: {
        IsStrValue: true,
        EventFieldName: 'SelectedRouteProbability',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Selected Route Probability',
          FieldName: 'selectedSplitChance',
          IsHidden: false,
          Roles: [
            'admin',
            'user'
          ],
          FieldType: 'string'
        }
      },
      respectedDuplicates: {
        IsStrValue: true,
        EventFieldName: 'respectedDuplicates',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Respected Duplicates',
          FieldName: 'respectedDuplicates',
          IsHidden: false,
          Roles: [
            'admin',
            'user'
          ],
          FieldType: 'bool'
        }
      }
    }
  },
  ConversionAdjustmentRequested: {
    Roles: ['admin', 'user', 'buyer'],
    EventName: 'ConversionAdjustmentRequested',
    DisplayNameForRoles: {
      buyer: 'Payout Adjustment Requested'
    },
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          Scubbers: 'date'
        }
      },
      amount: {
        IsValue: true,
        EventFieldName: 'AdjustmentAmount',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Requested Adjustment Amount',
          FieldName: 'amount',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      jobId: {
        IsStrValue: true,
        EventFieldName: 'RequestId',
        Field: {
          DisplayName: 'Request ID',
          FieldName: 'jobId',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      reason: {
        IsStrValue: true,
        EventFieldName: 'Reason',
        Field: {
          DisplayName: 'Reason',
          FieldName: 'reason',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerName: {
        IsStrValue: true,
        EventFieldName: 'targetBuyer',
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'buyerName',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerId: {
        IsStrValue: true,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'buyerId',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerSubId: {
        IsValue: false,
        EventFieldName: 'buyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'buyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  ConversionAdjustmentApproved: {
    Roles: ['admin', 'user', 'buyer'],
    EventName: 'ConversionAdjustmentApproved',
    DisplayNameForRoles: {
      buyer: 'Payout Adjustment Approved'
    },
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          Scubbers: 'date'
        }
      },
      amount: {
        IsValue: true,
        EventFieldName: 'AdjustmentAmount',
        Field: {
          DisplayName: 'Approved Adjustment Amount',
          FieldName: 'amount',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      conversionAmount: {
        IsValue: true,
        EventFieldName: 'ResultingConversion',
        Field: {
          DisplayName: 'Amount after Adjustment',
          FieldName: 'Resulting Conversion',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      jobId: {
        IsStrValue: true,
        EventFieldName: 'RequestId',
        Field: {
          DisplayName: 'Request ID',
          FieldName: 'jobId',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerName: {
        IsStrValue: true,
        EventFieldName: 'targetBuyer',
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'buyerName',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerId: {
        IsStrValue: true,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'buyerId',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerSubId: {
        IsValue: false,
        EventFieldName: 'buyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'buyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  ConversionAdjustmentRejected: {
    Roles: ['admin', 'user', 'buyer'],
    EventName: 'ConversionAdjustmentRejected',
    DisplayNameForRoles: {
      buyer: 'Payout Adjustment Rejected'
    },
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          Scubbers: 'date'
        }
      },
      amount: {
        IsValue: true,
        EventFieldName: 'AdjustmentAmount',
        Field: {
          DisplayName: 'Adjustment Amount',
          FieldName: 'amount',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      jobId: {
        IsStrValue: true,
        EventFieldName: 'RequestId',
        Field: {
          DisplayName: 'Request ID',
          FieldName: 'jobId',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      reason: {
        IsStrValue: true,
        EventFieldName: 'Reason',
        Field: {
          DisplayName: 'Reason',
          FieldName: 'reason',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerName: {
        IsStrValue: true,
        EventFieldName: 'targetBuyer',
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'buyerName',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerId: {
        IsStrValue: true,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'buyerId',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerSubId: {
        IsValue: false,
        EventFieldName: 'buyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'buyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      }
    }
  },
  ConvertedCall_Void: {
    Roles: ['admin', 'user', 'buyer'],
    EventName: 'ConvertedCall_Void',
    DisplayName: 'Conversion Adjusted',
    DisplayNameForRoles: {
      buyer: 'Payout Adjusted'
    },
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Conversion Adjustment Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          Scubbers: 'date'
        }
      },
      buyerName: {
        IsStrValue: true,
        EventFieldName: 'targetBuyer',
        Field: {
          DisplayName: 'targetBuyer',
          FieldName: 'buyerName',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      buyerId: {
        IsStrValue: true,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'targetBuyerId',
          FieldName: 'buyerId',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin', 'buyer', 'user'],
          FieldType: 'text'
        }
      },
      conversionAmount: {
        IsValue: true,
        EventFieldName: 'conversionAmount',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Adjustment Amount',
          FieldName: 'conversionAmount',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'currency',
          IsRange: true
        }
      },
      partialVoid: {
        IsValue: true,
        EventFieldName: 'partialVoid',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Partial Void',
          FieldName: 'partialVoid',
          IsHidden: true,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'bool'
        }
      }
    }
  },
  PayoutCall_void: {
    Roles: ['admin', 'user', 'affiliate'],
    EventName: 'PayoutCall_void',
    DisplayNameForRoles: {
      publisher: 'Revenue Adjusted'
    },
    DisplayName: 'Payout Adjusted',
    EventWeight: 1130,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Adjustment Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: true,
          Roles: ['admin', 'user', 'affiliate'],
          Scubbers: 'date'
        }
      },
      payoutAmount: {
        IsValue: true,
        EventFieldName: 'payoutAmount',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Adjustment Amount',
          FieldName: 'payoutAmount',
          IsHidden: true,
          Roles: ['admin', 'user', 'affiliate'],
          FieldType: 'currency',
          IsRange: true
        }
      },
      partialVoid: {
        IsValue: true,
        EventFieldName: 'partialVoid',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Partial Void',
          FieldName: 'partialVoid',
          IsHidden: true,
          Roles: ['admin', 'user', 'affiliate'],
          FieldType: 'bool'
        }
      }
    }
  },
  CallPlanDetail: {
    Roles: ['admin', 'user'],
    EventName: 'CallPlanDetail',
    DisplayName: 'Routing Plan',
    EventWeight: 100,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          Scubbers: 'date'
        }
      },
      ineligibleTargets: {
        IsStrValue: true,
        EventFieldName: 'IneligibleTargets',
        Field: {
          DisplayName: 'Ineligible Targets',
          FieldName: 'ineligibleTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      eligibleOrderedTargets: {
        IsStrValue: true,
        EventFieldName: 'EligibleTargets',
        Field: {
          DisplayName: 'Eligible Targets',
          FieldName: 'eligibleOrderedTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      }
    }
  },
  RTBRerouteEligibilitySummary: {
    Roles: ['admin', 'user'],
    EventName: 'RTBRerouteEligibilitySummary',
    DisplayName: 'RTB Reroute Eligibility Summary',
    EventWeight: 100,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          Scubbers: 'date'
        }
      },
      ineligibleTargets: {
        IsStrValue: true,
        EventFieldName: 'IneligibleTargets',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Ineligible Targets',
          FieldName: 'ineligibleTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      eligibleOrderedTargets: {
        IsStrValue: true,
        EventFieldName: 'EligibleTargets',
        FieldWeight: 2,
        Field: {
          DisplayName: 'Eligible Targets',
          FieldName: 'eligibleOrderedTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      }
    }
  },
  PingTreePingingSummary: {
    Roles: ['admin', 'user'],
    EventName: 'PingTreePingingSummary',
    DisplayName: 'Ring Tree Pinging Summary',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        FieldWeight: 0,
        Field: {
          DisplayName: 'Conversion Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          Scubbers: 'date'
        }
      },
      pingTreeName: {
        IsValue: false,
        EventFieldName: 'pingTreeName',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Ring Tree',
          FieldName: 'pingTreeName',
          FieldType: 'string',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'string'
        }
      },
      pingTreeId: {
        IsValue: false,
        EventFieldName: 'pingTreeId',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Ring Tree Id',
          FieldName: 'pingTreeId',
          FieldType: 'string',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'string'
        }
      },
      winningRingTreeTarget: {
        IsStrValue: true,
        EventFieldName: 'winningRingTreeTarget',
        FieldWeight: 3,
        Field: {
          DisplayName: 'Winning',
          FieldName: 'winningRingTreeTarget',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      acceptedRingTreeTargets: {
        IsStrValue: true,
        EventFieldName: 'acceptedRingTreeTargets',
        FieldWeight: 2,
        Field: {
          DisplayName: 'Accepted',
          FieldName: 'acceptedRingTreeTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      notAcceptedRingTreeTargets: {
        IsStrValue: true,
        EventFieldName: 'notAcceptedRingTreeTargets',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Not Accepted',
          FieldName: 'notAcceptedRingTreeTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      }
    }
  },
  SecondStepPassthroughPingingSummary: {
    Roles: ['admin', 'user'],
    EventName: 'SecondStepPassthroughPingingSummary',
    DisplayName: 'Confirmation Request Pinging Summary',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        FieldWeight: 0,
        Field: {
          DisplayName: 'Conversion Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'buyer', 'user'],
          Scubbers: 'date'
        }
      },
      pingTreeName: {
        IsValue: false,
        EventFieldName: 'pingTreeName',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Ring Tree',
          FieldName: 'pingTreeName',
          FieldType: 'string',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'string'
        }
      },
      pingTreeId: {
        IsValue: false,
        EventFieldName: 'pingTreeId',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Ring Tree Id',
          FieldName: 'pingTreeId',
          FieldType: 'string',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'string'
        }
      },
      winningRingTreeTarget: {
        IsStrValue: true,
        EventFieldName: 'winningRingTreeTarget',
        FieldWeight: 3,
        Field: {
          DisplayName: 'Winning',
          FieldName: 'winningRingTreeTarget',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      acceptedRingTreeTargets: {
        IsStrValue: true,
        EventFieldName: 'acceptedRingTreeTargets',
        FieldWeight: 2,
        Field: {
          DisplayName: 'Accepted',
          FieldName: 'acceptedRingTreeTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      notAcceptedRingTreeTargets: {
        IsStrValue: true,
        EventFieldName: 'notAcceptedRingTreeTargets',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Not Accepted',
          FieldName: 'notAcceptedRingTreeTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      }
    }
  },
  RPCCalculationSummary: {
    Roles: ['admin', 'user'],
    EventName: 'RPCCalculationSummary',
    DisplayName: 'RPC Calculation Summary',
    EventWeight: 150,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        FieldWeight: 0,
        Field: {
          DisplayName: 'Calculation Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin', 'user'],
          Scubbers: 'date'
        }
      },
      jsonId: {
        IsValue: false,
        EventFieldName: 'jsonId',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Json Id',
          FieldName: 'jsonId',
          FieldType: 'string',
          IsHidden: true,
          Roles: ['admin', 'user'],
          Scubbers: 'string'
        }
      },
      duplicate: {
        IsStrValue: true,
        EventFieldName: 'duplicate',
        FieldWeight: 3,
        Field: {
          DisplayName: 'Duplicate',
          FieldName: 'duplicate',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      errored: {
        IsStrValue: true,
        EventFieldName: 'errored',
        FieldWeight: 2,
        Field: {
          DisplayName: 'Errored',
          FieldName: 'errored',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      calculated: {
        IsStrValue: true,
        EventFieldName: 'calculated',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Calculated',
          FieldName: 'rpcCalculated',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      actualCount: {
        IsValue: true,
        EventFieldName: 'actualCount',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Total Targets',
          FieldName: 'actualCount',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'number',
          IsSearchable: false
        }
      },
      shown: {
        IsValue: true,
        EventFieldName: 'shown',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Shown Targets',
          FieldName: 'shown',
          IsHidden: false,
          Roles: ['admin', 'user'],
          FieldType: 'number',
          IsSearchable: false
        }
      }
    }
  },
  PingRAWResult: {
    Roles: ['admin'],
    EventName: 'PingRAWResult',
    DisplayName: 'Ring Tree Target Raw Result',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      httpStatusCode: {
        IsValue: true,
        EventFieldName: 'httpStatusCode',
        Field: {
          DisplayName: 'Http Status Code',
          FieldName: 'httpStatusCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          IsSearchable: false
        }
      },
      url: {
        IsStrValue: true,
        EventFieldName: 'url',
        Field: {
          DisplayName: 'URL',
          FieldName: 'url',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      method: {
        IsStrValue: true,
        EventFieldName: 'method',
        Field: {
          DisplayName: 'Method',
          FieldName: 'method',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'RequestBody',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'ResponseBody',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'ErrorMessage',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestStatus: {
        IsStrValue: true,
        EventFieldName: 'requestStatus',
        Field: {
          DisplayName: 'RequestStatus',
          FieldName: 'requestStatus',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      }
    }
  },
  PingSuccess: {
    Roles: ['admin'],
    EventName: 'PingSuccess',
    DisplayName: 'Ring Tree Target Success',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      bid: {
        IsValue: true,
        EventFieldName: 'bid',
        Field: {
          DisplayName: 'Bid',
          FieldName: 'bid',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      staticRevenueAmount: {
        IsValue: true,
        EventFieldName: 'staticRevenueAmount',
        Field: {
          DisplayName: 'Static Revenue Amount',
          FieldName: 'staticRevenueAmount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      dynamicCallLength: {
        IsValue: true,
        EventFieldName: 'dynamicCallLength',
        Field: {
          DisplayName: 'Dynamic Call Length',
          FieldName: 'dynamicCallLength',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'seconds',
          IsSearchable: false
        }
      },
      staticConversionCallLengthValue: {
        IsValue: true,
        EventFieldName: 'staticConversionCallLengthValue',
        Field: {
          DisplayName: 'Static Call Length',
          FieldName: 'staticConversionCallLengthValue',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'seconds',
          IsSearchable: false
        }
      },
      ptnumber: {
        IsStrValue: true,
        EventFieldName: 'ptnumber',
        Field: {
          DisplayName: 'Number',
          FieldName: 'ptnumber',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      },
      accepted: {
        IsStrValue: true,
        EventFieldName: 'accepted',
        Field: {
          DisplayName: 'Accepted',
          FieldName: 'accepted',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      minimumRevenueAmount: {
        IsValue: true,
        EventFieldName: 'minimumRevenueAmount',
        Field: {
          DisplayName: 'Min Revenue Amount',
          FieldName: 'minimumRevenueAmount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      pingTimeout: {
        IsValue: true,
        EventFieldName: 'pingTimeout',
        Field: {
          DisplayName: 'Ping Timeout',
          FieldName: 'pingTimeout',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      maxDynamicDuration: {
        IsValue: true,
        EventFieldName: 'maxDynamicDuration',
        Field: {
          DisplayName: 'Max Dynamic Duration',
          FieldName: 'maxDynamicDuration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'seconds',
          IsSearchable: false
        }
      }
    }
  },
  PingFailure: {
    Roles: ['admin'],
    EventName: 'PingFailure',
    DisplayName: 'Ring Tree Target Failure',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      pingTimeout: {
        IsValue: true,
        EventFieldName: 'pingTimeout',
        Field: {
          DisplayName: 'Ping Timeout',
          FieldName: 'pingTimeout',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      error: {
        IsStrValue: true,
        EventFieldName: 'error',
        Field: {
          DisplayName: 'error',
          FieldName: 'error',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      }
    }
  },
  SecondPingRAWResult: {
    Roles: ['admin'],
    EventName: 'SecondPingRAWResult',
    DisplayName: 'Confirmation Request Raw Result',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      httpStatusCode: {
        IsValue: true,
        EventFieldName: 'httpStatusCode',
        Field: {
          DisplayName: 'Http Status Code',
          FieldName: 'httpStatusCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          IsSearchable: false
        }
      },
      url: {
        IsStrValue: true,
        EventFieldName: 'url',
        Field: {
          DisplayName: 'URL',
          FieldName: 'url',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      method: {
        IsStrValue: true,
        EventFieldName: 'method',
        Field: {
          DisplayName: 'Method',
          FieldName: 'method',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'RequestBody',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'ResponseBody',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'ErrorMessage',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestStatus: {
        IsStrValue: true,
        EventFieldName: 'requestStatus',
        Field: {
          DisplayName: 'RequestStatus',
          FieldName: 'requestStatus',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      }
    }
  },
  SecondPingSuccess: {
    Roles: ['admin'],
    EventName: 'SecondPingSuccess',
    DisplayName: 'Confirmation Request Success',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      ptnumber: {
        IsStrValue: true,
        EventFieldName: 'ptnumber',
        Field: {
          DisplayName: 'Number',
          FieldName: 'ptnumber',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      pingTimeout: {
        IsValue: true,
        EventFieldName: 'pingTimeout',
        Field: {
          DisplayName: 'Ping Timeout',
          FieldName: 'pingTimeout',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
    }
  },
  SecondPingFailure: {
    Roles: ['admin'],
    EventName: 'SecondPingFailure',
    DisplayName: 'Confirmation Request Failure',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      pingTimeout: {
        IsValue: true,
        EventFieldName: 'pingTimeout',
        Field: {
          DisplayName: 'Ping Timeout',
          FieldName: 'pingTimeout',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      error: {
        IsStrValue: true,
        EventFieldName: 'error',
        Field: {
          DisplayName: 'error',
          FieldName: 'error',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      },
      targetName: {
        IsValue: false,
        EventFieldName: 'targetName',
        Field: {
          DisplayName: 'Target Name',
          FieldName: 'targetName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetId: {
        IsValue: false,
        EventFieldName: 'targetId',
        Field: {
          DisplayName: 'Target ID',
          FieldName: 'targetId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetSubId: {
        IsValue: false,
        EventFieldName: 'targetSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Target Sub ID',
          FieldName: 'targetSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerId: {
        IsValue: false,
        EventFieldName: 'targetBuyerId',
        Field: {
          DisplayName: 'Buyer ID',
          FieldName: 'targetBuyerId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyerSubId: {
        IsValue: false,
        EventFieldName: 'targetBuyerSubId',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer Sub ID',
          FieldName: 'targetBuyerSubId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      targetBuyer: {
        IsValue: false,
        EventFieldName: 'targetBuyer',
        ShouldFlaten: true,
        Field: {
          DisplayName: 'Buyer',
          FieldName: 'targetBuyer',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      }
    }
  },
  PingTreeProcessFailure: {
    Roles: ['admin'],
    EventName: 'PingTreeProcessFailure',
    DisplayName: 'Ring Tree Failure',
    EventWeight: 300,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      failReason: {
        IsStrValue: true,
        EventFieldName: 'failReason',
        Field: {
          DisplayName: 'Error',
          FieldName: 'failReason',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      },
      pingTreeName: {
        IsValue: false,
        EventFieldName: 'pingTreeName',
        Field: {
          DisplayName: 'Ring Tree Name',
          FieldName: 'pingTreeName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text'
        }
      },
      pingTreeId: {
        IsValue: false,
        EventFieldName: 'pingTreeId',
        Field: {
          DisplayName: 'Ring Tree ID',
          FieldName: 'pingTreeId',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'text'
        }
      }
    }
  },
  DataEnrichment: {
    Roles: ['admin'],
    EventName: 'DataEnrichment',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      success: {
        IsStrValue: true,
        EventFieldName: 'success',
        Field: {
          DisplayName: 'success',
          FieldName: 'success',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'errorMessage',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      amount: {
        IsValue: true,
        EventFieldName: 'cost',
        Field: {
          DisplayName: 'amount',
          FieldName: 'amount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          IsSearchable: false
        }
      }
    }
  },
  BlacklistCheck: {
    Roles: ['admin'],
    EventName: 'BlacklistCheck',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      result: {
        IsStrValue: true,
        EventFieldName: 'result',
        Field: {
          DisplayName: 'result',
          FieldName: 'result',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'errorMessage',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      amount: {
        IsValue: true,
        EventFieldName: 'cost',
        Field: {
          DisplayName: 'amount',
          FieldName: 'amount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          Scubbers: 'positive',
          IsSearchable: false
        }
      }
    }
  },
  JornayaTCPACheck: {
    Roles: ['admin'],
    EventName: 'JornayaTCPACheck',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      result: {
        IsStrValue: true,
        EventFieldName: 'result',
        Field: {
          DisplayName: 'Result',
          FieldName: 'result',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseCode: {
        IsValue: true,
        EventFieldName: 'cost',
        Field: {
          DisplayName: 'Response Code',
          FieldName: 'responseCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      }
    }
  },
  TrustedFormCheck: {
    Roles: ['admin'],
    EventName: 'TrustedFormCheck',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      result: {
        IsStrValue: true,
        EventFieldName: 'result',
        Field: {
          DisplayName: 'Result',
          FieldName: 'result',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'Request Body',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      certificateId: {
        IsStrValue: true,
        EventFieldName: 'certificateId',
        Field: {
          DisplayName: 'Certificate Id',
          FieldName: 'certificateId',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseCode: {
        IsValue: true,
        EventFieldName: 'responseCode',
        Field: {
          DisplayName: 'Response Code',
          FieldName: 'responseCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      },
      integrationMethod: {
        IsStrValue: true,
        EventFieldName: 'integrationMethod',
        Field: {
          DisplayName: 'Integration Method',
          FieldName: 'integrationMethod',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      }
    }
  },
  CustomDataEnrichmentSuccess: {
    Roles: ['admin'],
    EventName: 'CustomDataEnrichmentSuccess',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      customEnrichmentID: {
        IsStrValue: true,
        EventFieldName: 'customEnrichmentID',
        Field: {
          DisplayName: 'Custom Enrichment ID',
          FieldName: 'customEnrichmentID',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      customEnrichmentName: {
        IsStrValue: true,
        EventFieldName: 'customEnrichmentName',
        Field: {
          DisplayName: 'Custom Enrichment Name',
          FieldName: 'customEnrichmentName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      requestUrl: {
        IsStrValue: true,
        EventFieldName: 'requestUrl',
        Field: {
          DisplayName: 'Request URL',
          FieldName: 'requestUrl',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'Request Body',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseCode: {
        IsValue: true,
        EventFieldName: 'responseCode',
        Field: {
          DisplayName: 'Response Code',
          FieldName: 'responseCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      },
      appendedTagsCount: {
        IsValue: true,
        EventFieldName: 'appendedTagsCount',
        Field: {
          DisplayName: 'Appended Tags Count',
          FieldName: 'appendedTagsCount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      }
    }
  },
  CustomDataEnrichmentFailure: {
    Roles: ['admin'],
    EventName: 'CustomDataEnrichmentFailure',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      customEnrichmentID: {
        IsStrValue: true,
        EventFieldName: 'customEnrichmentID',
        Field: {
          DisplayName: 'Custom Enrichment ID',
          FieldName: 'customEnrichmentID',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      customEnrichmentName: {
        IsStrValue: true,
        EventFieldName: 'customEnrichmentName',
        Field: {
          DisplayName: 'Custom Enrichment Name',
          FieldName: 'customEnrichmentName',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      requestUrl: {
        IsStrValue: true,
        EventFieldName: 'requestUrl',
        Field: {
          DisplayName: 'Request URL',
          FieldName: 'requestUrl',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'Request Body',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseCode: {
        IsValue: true,
        EventFieldName: 'responseCode',
        Field: {
          DisplayName: 'Response Code',
          FieldName: 'responseCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Fail Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
    }
  },

  JavascriptError: {
    Roles: ['admin'],
    EventName: 'JavascriptError',
    DisplayName: 'Javascript Error',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        ShouldFlaten: false,
        Override: false,
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: [
            'admin'
          ],
          FieldType: 'string'
        }
      }
    }
  },
  RTBWinningBid: {
    Roles: ['admin'],
    EventName: 'RTBWinningBid',
    DisplayName: 'RTB Winning Bid',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      callerId: {
        IsStrValue: true,
        EventFieldName: 'callerId',
        Field: {
          DisplayName: 'Caller ID',
          FieldName: 'callerId',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      callAccepted: {
        IsValue: true,
        EventFieldName: 'callAccepted',
        Field: {
          DisplayName: 'Call Accepted',
          FieldName: 'callAccepted',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'bool'
        }
      },
      bidAmount: {
        IsValue: true,
        EventFieldName: 'bidAmount',
        Field: {
          DisplayName: 'Bid Amount',
          FieldName: 'bidAmount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          Scubbers: 'positive',
          IsSearchable: false
        }
      }
    }
  },
  TargetHangupRerouteSummary: {
    roles: ['admin', 'user'],
    EventName: 'TargetHangupRerouteSummary',
    DisplayName: 'Revenue Recovery Summary',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        dtStamp: {
          IsValue: false,
          EventFieldName: 'dtStamp',
          ShouldFlaten: false,
          Field: {
            DisplayName: 'Timestamp',
            FieldName: 'dtStamp',
            FieldType: 'date',
            IsHidden: false,
            Roles: ['admin', 'user', 'buyer'],
            Scubbers: 'date'
          }
        }
      },
      name: {
        IsStrValue: true,
        EventFieldName: 'name',
        Field: {
          DisplayName: 'Name',
          FieldName: 'name',
          IsHidden: false,
          Roles: ['admin', 'user', 'buyer'],
          FieldType: 'string'
        }
      },
      notAcceptedTargets: {
        IsStrValue: true,
        EventFieldName: 'notAcceptedTargets',
        FieldWeight: 400,
        Field: {
          DisplayName: 'Ineligible Targets',
          FieldName: 'notAcceptedTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list'
        }
      },
      acceptedTargets: {
        IsStrValue: true,
        EventFieldName: 'acceptedTargets',
        FieldWeight: 500,
        Field: {
          DisplayName: 'Eligible Targets',
          FieldName: 'acceptedTargets',
          IsHidden: true,
          Roles: ['admin', 'user'],
          FieldType: 'list'
        }
      },
    }
  }
};
